import { ImageStore } from "context";
import React from "react";

import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./containers/App";
import "./index.scss";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ImageStore>
        <App />
      </ImageStore>
    </BrowserRouter>
  </React.StrictMode>
);
